import { render, staticRenderFns } from "./CardCourse.vue?vue&type=template&id=2e786abf&scoped=true&"
import script from "./CardCourse.vue?vue&type=script&lang=js&"
export * from "./CardCourse.vue?vue&type=script&lang=js&"
import style0 from "./CardCourse.vue?vue&type=style&index=0&id=2e786abf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e786abf",
  null
  
)

export default component.exports